import React, {useEffect, useRef, useState} from "react";
import {Popconfirm} from "antd";

const PopconfirmWrapper = (props) => {
    const {children, title, description, placement = 'left', cancelText = 'Cancel', okText = 'OK', cancelButtonProps = {}, okButtonProps = {}, onCancel, onConfirm} = props;
    const [isOpen, setOpen] = useState(false);
    const [popconfirmNode, setPopconfirmNode] = useState(null);
    const titleRef = useRef();
    const descriptionRef = useRef();
    const cancelButtonRef = useRef();
    const okButtonRef = useRef();
    const childrenRef = useRef();

    useEffect(() => {
        if (isOpen) {
            setTimeout(() => {
                const popconfirmNodes = document.querySelectorAll('.ant-popover:not(.ant-popover-hidden)');

                popconfirmNodes.forEach(node => {
                    if (node.contains(titleRef.current) || node.contains(descriptionRef.current)) setPopconfirmNode(node);
                });
            }, 0);
        }
    }, [isOpen]);

    useEffect(() => {
        if (popconfirmNode) {
            cancelButtonRef.current?.focus();
            popconfirmNode.addEventListener('keydown', handleKeyDown);
            document.addEventListener('focusin', handleFocusOut);
            document.addEventListener('click', handleFocusOut);
            window.addEventListener('blur', handleClose);

            return () => {
                popconfirmNode?.removeEventListener('keydown', handleKeyDown);
                document.removeEventListener('focusin', handleFocusOut);
                document.removeEventListener('click', handleFocusOut);
                window.removeEventListener('blur', handleClose);
            }
        }
    }, [popconfirmNode]);

    const handleKeyDown = (e) => {
        if (e.code == 'Escape') {
            handleClose();
        }
    }

    const handleFocusOut = (e) => {
        if (popconfirmNode && !popconfirmNode.contains(e.target)) {
            handleClose();
        }
    }

    const handleClose = () => {
        setOpen(false);
        setPopconfirmNode(null);

        if (onCancel && typeof onCancel == 'function') {
            onCancel();
        }

        if (childrenRef.current) {
            childrenRef.current.focus();
        }
    }

    return (
        <Popconfirm
            title={title ? <span ref={titleRef}>{title}</span> : null}
            description={description ? <span ref={descriptionRef}>{description}</span> : null}
            placement={placement}
            cancelText={cancelText}
            okText={okText}
            cancelButtonProps={{...cancelButtonProps, ref: cancelButtonRef, className: 'ch-pc-btn ch-btn-text'}}
            okButtonProps={{...okButtonProps, ref: okButtonRef, className: 'ch-pc-btn'}}
            open={isOpen}
            onOpenChange={(open) => setOpen(open)}
            onCancel={handleClose}
            onConfirm={onConfirm}
        >
            {(typeof type !== 'object') && children}
            {(typeof type === 'object' && type.$$typeof === Symbol.for('react.forward_ref')) && React.cloneElement(children, {ref: childrenRef})}
        </Popconfirm>
    );
}

export default PopconfirmWrapper;